import { render } from "./SceneUniqueChoiceImage.vue?vue&type=template&id=39380bce&scoped=true"
import script from "./SceneUniqueChoiceImage.vue?vue&type=script&lang=js"
export * from "./SceneUniqueChoiceImage.vue?vue&type=script&lang=js"

import "./SceneUniqueChoiceImage.vue?vue&type=style&index=0&id=39380bce&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.35_vue@3.5.35_webpack@5.107.2_cssnano@5.1.15_postcss@8.5.15__postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39380bce"]])

export default __exports__